import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'

// Elements
import BackToTop from './elements/back-top';
import PageScrollTop from './elements/page-scroll-top';

// All Pages Router
import Index from './pages/index';
import AboutUs from './pages/about-us';
import AboutBestCenter from './pages/about-us-best';
 
import ServiceE from './pages/service_e';
import ServiceC from './pages/service_c';
import ServiceCT from './pages/service_ct';
import ServiceERGE from './pages/service_erge';
import ServiceT from './pages/service_t';
import Hospital from './pages/hospitales';
import EquipoCalificado from './pages/equipo_calificado';
import ServiceCover from './pages/service_co';

import enf_digestivas_quirurgicas from './pages/enf_digestivas_quirurgicas';
import enf_digestivas_medicas from './pages/enf_digestivas_medicas';

import FormularioCitas from './pages/newForm';
// import blog_grid from './pages/blog-grid';
// <Route path='/blogs' exact component={blog_grid} />
// import blog_detail from './pages/blog-details';
// <Route path={'/blog-detail/:id'} exact component={blog_detail}></Route>
import ContactUs from './pages/contact-us';
 
import Error from './pages/error-404';
import Cofepris from './pages/cofepris';

class Markup extends Component{
	render(){
		return(
			<>
				<BrowserRouter basename={'/'}>
				
					<Switch>
					
						<Route path='/' exact component={Index} />
						<Route path='/about-us' exact component={AboutUs} />
						<Route path='/cofepris' exact component={Cofepris} />
						<Route path='/acerca-de' exact component={AboutBestCenter} />
 
						<Route path='/service_c' exact component={ServiceC} />
						<Route path='/service_ct' exact component={ServiceCT} />
						<Route path='/service_erge' exact component={ServiceERGE} />
						<Route path='/cobertura' exact component={ServiceCover} />
						<Route path='/service_e' exact component={ServiceE} />
						<Route path='/service_t' exact component={ServiceT} />
						<Route path='/hospitales' exact component={Hospital} />
						<Route path='/equipo_calificado' exact component={EquipoCalificado} />
 
						<Route path='/contact-us' exact component={ContactUs} />
						<Route path='/enf_digestivas_quirurgicas' exact component={enf_digestivas_quirurgicas} />
						<Route path='/enf_digestivas_medicas' exact component={enf_digestivas_medicas} />

						<Route path='/citas' exact component={FormularioCitas} />
						
			 
						<Route component={Error} />
						
					</Switch>
					
					<PageScrollTop />
					
				</BrowserRouter>
				
				<BackToTop />
				
			</>
		);
	}
}

export default Markup;